import axios from '../index';

export const requestBinaryCreate = ({ data }) => axios.post(`/fhir/Binary/`, data);
